<div class="wrapper" [ngClass]="{'parent-style': parentDashboard}" *transloco="let t; read: 'newStudentModal'">


    <div *ngIf="!beforeSchool" class="top-block">
        <div class="title" *ngIf="!isParentRole">{{ t('child.title') }}</div>

        <div class="title" *ngIf="isParentRole"> {{ t('parent.title') }}</div>

        <div class="result-wrapper">

            <div class="title"> {{ t('englishLevel') }}</div>

            <div class="level"> {{ title }}</div>

<!--                    <div class="info" (click)="goToLink()">-->
<!--                        <img src="assets/images/icons/info24x24.svg" alt="info">-->

<!--                    </div>-->

            <div class="informer" >
                <div class="info-details">
                    <div class="informer-popover d-none ">
                        <div class="info agreement">
                            <div *ngIf="!isParentRole">{{ t('englishLevelSystem')}}
                                <a [routerLink]="'/'"  (click)="goToLink()"> {{ t('here') }}</a>
                                🙂

                            </div>
                            <div *ngIf="isParentRole">{{ t('parent.englishLevelSystem')}}
                                <a [routerLink]="'/'"  (click)="goToLink()">{{ t('here') }}</a>
                                🙂

                            </div>
                        </div>

                    </div>


                    <img src="assets/images/icons/info24x24.svg" alt="info">
                </div>

            </div>





        </div>


    </div>


    <div class="slogan" *ngIf="!isParentRole" [innerHTML]="t('child.answer')" >
<!--        {{t('child.answer')}}-->
    </div>

    <div class="slogan" *ngIf="isParentRole" [innerHTML]="t('parent.answer')">
<!--        {{t('parent.answer')}}-->
    </div>



    <div class="btn-wrapper" *ngIf="!secondTryTestLink && (withButtonRequest || beforeSchool)">

        <button type="button" class="btn dark-btn" (click)="openRequestModal('startStudy')"> {{ t('leaveRequest') }}</button>
    </div>

    <div *ngIf="secondTryTestLink" class="second-try-test-wrapper">
        <div class="devided-block" *ngIf="!isParentRole">
            <div class="title">  {{ t('or') }} </div>
        </div>


        <div class="slogan" *ngIf="!isParentRole" [innerHTML]="t('child.oneMoreTry')">
<!--            {{ t('child.oneMoreTry') }}-->
        </div>

        <div class="btn-wrapper" *ngIf="!isParentRole">

            <button type="button" class="btn dark-btn"  *ngIf="secondTryTestLink" (click)="goToTest()">   {{ t('doTestAgain') }} </button>
        </div>

    </div>





</div>
